@if (visible) {
  <mat-progress-bar [bufferValue]="bufferValue" [mode]="mode" [value]="value" color="accent"></mat-progress-bar>
}
